import { IconProps } from 'types/icons';

export default function RejectIcon(props: IconProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2409_2140)">
        <path
          d="M10 6l-4 4m0-4l4 4m4.667-2A6.667 6.667 0 111.333 8a6.667 6.667 0 0113.334 0z"
          stroke="#900B09"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2409_2140">
          <path fill="#fff" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
